<div [matMenuTriggerFor]="options.menu" #langMenuTrigger="matMenuTrigger" mat-menu-item>
  <app-pencil-menu-item
    data-name="spaces-manager-user-avatar-menu-language"
    [forMenu]="true"
    icon="translate"
    [iconConfig]="{ type: IconTypes.materialIcon }"
    [label]="'Language' | translate"
    (clickEvent)="options.open($event, langMenuTrigger)"
  ></app-pencil-menu-item>
</div>

<app-language-menu
  #options
  [xPosition]="(rtl$ | async) ? 'after' : 'before'"
  dataNamePrefix="spaces-manager-user-avatar-menu-language-selection-"
  dataNameField="originalLabel"
></app-language-menu>
